// Helper to get random date within last 5 days
const getRandomDate = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 5);

  const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

  // Format: DD-MM-YYYY
  const day = String(randomDate.getDate()).padStart(2, '0');
  const month = String(randomDate.getMonth() + 1).padStart(2, '0');
  const year = randomDate.getFullYear();

  // Format: HH.MM AM/PM
  let hours = randomDate.getHours();
  const minutes = String(randomDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const strHours = String(hours).padStart(2, '0');

  return `${day}-${month}-${year} | ${strHours}.${minutes} ${ampm}`;
};

const getRandomISODate = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - 5);
  const date = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));

  const pad = (num) => String(num).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const updateAnalyticsData = (data) => {
  return data.map(entry => {
    if (entry.analytics) {
      return {
        ...entry,
        analytics: entry.analytics.map(subEntry => ({
          ...subEntry,
          node: getRandomISODate()
        }))
      };
    } else if (entry.node) {
      return {
        ...entry,
        node: getRandomISODate()
      };
    }
    return entry;
  });
};

const updateStatsRecursive = (statsObj) => {
  if (!statsObj) return statsObj;
  const newStats = { ...statsObj };
  ['day', 'weekly', 'monthly', 'yearly'].forEach(period => {
    if (newStats[period] && newStats[period].analyticsData) {
      newStats[period] = {
        ...newStats[period],
        analyticsData: updateAnalyticsData(newStats[period].analyticsData)
      };
    }
  });
  return newStats;
};

const updateItemDates = (item) => {
  const newItem = { ...item };
  Object.keys(newItem).forEach(key => {
    if (key.endsWith('Stats') && newItem[key] && typeof newItem[key] === 'object') {
      newItem[key] = updateStatsRecursive(newItem[key]);
    }
  });
  return newItem;
};




export const updateInfoData = (infoData) => {
  if (!infoData) return infoData;
  const newData = { ...infoData };
  if (newData.trips) {
    newData.trips = newData.trips.map(trip => ({
      ...trip,
      routeDetails: {
        ...trip.routeDetails,
        routeStops: {
          ...trip.routeDetails.routeStops,
          stoppages: trip.routeDetails.routeStops.stoppages.map(stop => ({
            ...stop,
            timeStamp: getRandomDate()
          }))
        }
      }
    }));
  }
  if (newData.pastViolations) {
    newData.pastViolations = newData.pastViolations.map(v => ({
      ...v,
      timeStamp: getRandomDate()
    }));
  }
  if (newData.nextMaintanance) {
    const date = new Date();
    date.setDate(date.getDate() + 15);
    const pad = (n) => String(n).padStart(2, '0');
    newData.nextMaintanance = `${pad(date.getMonth() + 1)}-${pad(date.getDate())}-${date.getFullYear()}`;
  }
  return newData;
};

// Timestamp cache to preserve dates across re-renders
const timestampCache = new Map();

export const getCachedTimestamp = (key) => {
  if (!timestampCache.has(key)) {
    timestampCache.set(key, getRandomDate());
  }
  return timestampCache.get(key);
};

export const formattedCardListData = (tabIndex, data, type) => {
  const dataList = [];
  const getNotificationList = (data) => {
    let notListData = {};
    switch (type) {
      case "events":
        notListData = data?.notifications?.events?.eventsList;
        break;
      case "incidents":
        notListData = data?.notifications?.incidents?.incidentsList;
        break;
      case "oprAlerts":
        notListData = data?.notifications?.oprAlerts?.oprAlertsList;
        break;
      default:
        break;
    }
    notListData &&
      notListData.length > 0 &&
      notListData.map((item) => {
        const cacheKey = `notification-${item?.busNo}-${item?.incident}-${item?.route}`;
        dataList.push({
          title: `${item?.incident}${" | "}${item?.busNo}${" | "}${"Route - "}${item?.route
            }`,
          source: item?.source?.locality,
          destination: item?.destination?.locality,
          timeStamp: getCachedTimestamp(cacheKey),
          driver: `${"Driver - "}${item?.driver}`,
          licenseNumber: `${"License Number - "}${item?.licenceNo}`,
          currentLocation: item?.currentLocation?.locality,
          sourceCoOrdinates: item?.source?.coOrdinates,
          destinationCoOrdinates: item?.destination?.coOrdinates,
          currentLocationCoOrdinates: item?.currentLocation?.coOrdinates,
          nextStopCoOrdinates: item?.nextStop?.coOrdinates,
          busNo: item?.busNo,
        });
      });
    return dataList;
  };
  const getBusesList = (data) => {
    data?.buses?.map((item) => {
      const cacheKey = `bus-${item?.busNo}-${item?.route}`;
      dataList.push({
        busNo: item?.busNo,
        title: `BUS#${item?.busNo}${" | "}${"Route - "}${item?.route}`,
        source: item?.source?.area,
        destination: item?.destination?.area,
        timeStamp: getCachedTimestamp(cacheKey),
        currentLocation: item?.currentLocation?.area,
        nextStop: item?.nextStop?.area,
        speed: item?.speed,
        distance: item?.distanceCovered,
        stops: item?.stops,
        fuelConsumed: item?.fuelConsumed,
        distance: item?.distanceCovered,
        driver: item?.driver,
        sourceCoOrdinates: item?.source?.coOrdinates,
        destinationCoOrdinates: item?.destination?.coOrdinates,
        currentLocationCoOrdinates: item?.currentLocation?.coOrdinates,
        nextStopCoOrdinates: item?.nextStop?.coOrdinates,
      });
    });
    return dataList;
  };
  const getDriversList = (data) => {
    data?.drivers?.map((item) => {
      const cacheKey = `driver-${item?.driver}-${item?.route}`;
      dataList.push({
        title: `${item?.driver}${" | "}${"Route - "}${item?.route}`,
        source: item?.source?.area,
        destination: item?.destination?.area,
        timeStamp: getCachedTimestamp(cacheKey),
        licenseNumber: item?.licenseNo,
        busNo: item?.busNo,
        workStatus: item?.workStatus,
        violations: item?.violations,
        distance: item?.distanceCovered,
        speed: item?.speed,
        busPlateNo: item?.busLicensePlateNo,
        imageUrl: item?.avatarImg,
        sourceCoOrdinates: item?.source?.coOrdinates,
        destinationCoOrdinates: item?.destination?.coOrdinates,
        currentLocationCoOrdinates: item?.currentLocation?.coOrdinates,
        nextStopCoOrdinates: item?.nextStop?.coOrdinates,
      });
    });
    return dataList;
  };
  const getRoutesList = (data) => {
    let routeListData = {};
    switch (type) {
      case "activeRoutes":
        routeListData = data?.activeRoutes?.routes;
        break;
      case "completedRoutes":
        routeListData = data?.completedRoutes?.routes;
        break;
      default:
        break;
    }
    routeListData &&
      routeListData.length > 0 &&
      routeListData.map((item) => {
        const cacheKey = `route-${item?.route}-${item?.busId}-${type}`;
        dataList.push({
          title: item?.route,
          busNo: item?.busId,
          source: item?.source?.area,
          destination: item?.destination?.area,
          timeStamp: getCachedTimestamp(cacheKey),
          currentLocation: item?.currentLocation?.area,
          nextStop: item?.nextStop?.area,
          buses: item?.noOfBuses,
          stops: item?.stops,
          fuelConsumed: item?.fuelConsumed,
          distance: item?.distanceCovered,
          driver: item?.driver,
          sourceCoOrdinates: item?.source?.coOrdinates,
          destinationCoOrdinates: item?.destination?.coOrdinates,
          currentLocationCoOrdinates: item?.currentLocation?.coOrdinates,
          nextStopCoOrdinates: item?.nextStop?.coOrdinates,
        });
      });
    return dataList;
  };
  switch (tabIndex) {
    case 0:
      return getNotificationList(data);
    case 1:
      return getBusesList(data);
    case 2:
      return getDriversList(data);
    case 3:
      return getRoutesList(data);
    default:
      break;
  }
};

export const formattedAnalyticsListData = (label, data) => {
  const dataList = [];

  const getBusesAnalyticsList = (data) => {
    data?.busAnalytics?.map((item) => {
      dataList.push(updateItemDates({
        title: `Bus# ${item?.busNo}`,
        licenseNumber: `License Plate Number - ${item?.busLicensePlateNo}`,
        generalStats: item?.generalStats,
        incomeStats: item?.incomeStats,
        distanceTravelledStats: item?.distanceTravelledStats,
        fuelConsumedStats: item?.fuelConsumedStats,
        travellingHoursStats: item?.travellingHoursStats,
        co2EmissionStats: item?.co2EmissionStats,
        expensesStats: item?.expensesStats,
      }));
    });
    return dataList;
  };

  const getDriversAnalyticsList = (data) => {
    data?.driverAnalytics?.map((item) => {
      dataList.push(updateItemDates({
        title: item?.name,
        licenseNumber: `Driving License Number - ${item?.licenseNo}`,
        generalStats: item?.generalStats,
        tripStats: item?.tripStats,
        avgDistanceDrivenStats: item?.avgDistanceDrivenStats,
        labourCostStats: item?.labourCostStats,
        driveTimeStats: item?.driveTimeStats,
        violationsStats: item?.violationsStats,
      }));
    });
    return dataList;
  };

  const getRoutesAnalyticsList = (data) => {
    data?.routeAnalytics?.map((item) => {
      dataList.push(updateItemDates({
        title: `Route# ${item?.route}`,
        generalStats: item?.generalStats,
        incomeStats: item?.incomeStats,
        passengersStats: item?.passengersStats,
        fuelEconomyStats: item?.fuelEconomyStats,
        avgBusesStats: item?.avgBusesStats,
        top5BusyRouteStats: item?.top5BusyRouteStats,
        stopsStats: item?.stopsStats,
      }));
    });
    return dataList;
  };

  switch (label) {
    case "buses":
      return getBusesAnalyticsList(data);
    case "drivers":
      return getDriversAnalyticsList(data);
    case "routes":
      return getRoutesAnalyticsList(data);
    default:
      break;
  }
};
